import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AsyncPipe } from '@angular/common';

import { TranslatePipe } from '@ngx-translate/core';

import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { AddToHomeScreenService } from '../../services/add-to-home-screen/add-to-home-screen.service';
import { GanLucidIcon } from '@gan/shared/ui-icon';

import { environment } from '@gan/core/util-environment';

@Component({
  selector: 'gan-add-to-home-screen',
  templateUrl: './add-to-home-screen.component.html',
  styleUrls: ['./add-to-home-screen.component.scss'],
  providers: [AddToHomeScreenService],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AsyncPipe, TranslatePipe, GanLucidIcon]
})
export class AddToHomeScreenComponent {
  readonly addToHomeScreenService = inject(AddToHomeScreenService);
  readonly title = inject(Title);
  readonly isLocal = environment.APP_URL.includes('localhost');

  /**
   * Either display banner immediately or by condition.
   * Load script and event listeners are not impacted
   */
  readonly displayBanner = input(true);

  readonly hostname = window.location.hostname;
  readonly hideBanner$ = combineLatest([
    this.addToHomeScreenService.userDismissed$,
    this.addToHomeScreenService.userInstalled$,
    this.addToHomeScreenService.isStandalone$,
  ]).pipe(
    map(([userDismissed, userInstalled, isStandalone]: boolean[]) => {
      console.log(`userDismissed:`, userDismissed, `userInstalled:`, userInstalled, `isStandalone:`, isStandalone);

      return userDismissed || userInstalled || isStandalone;
    })
  );

  constructor() {
    const addToHomeScreenService = this.addToHomeScreenService;

    addToHomeScreenService.trackStandalone();

    window.addEventListener('beforeinstallprompt', (e) => {
      console.log('beforeinstallprompt', e);

      // show the add button
      addToHomeScreenService.promptIntercepted$.next(true);

      // Prevent Chrome 67 and earlier from automatically showing the prompt
      // no matter what, the snack-bar shows in 68
      e.preventDefault();

      // Stash the event, so it can be displayed when the user wants.
      addToHomeScreenService.deferredPrompt = e;
    });

    window.addEventListener('appinstalled', (evt) => {
      console.log('appinstalled event', evt);

      addToHomeScreenService.trackInstalled();
    });
  }

  onDismiss(): void {
    this.addToHomeScreenService.userDismissed$.next(true);
  }
}
